/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 30px;
`;
Wrapper.displayName = 'Wrapper';

export const Text = styled.div`
  display: flex;
  align-items: center;
  font-size: 11px;
  color: ${({ theme }) => theme.textfield.text};
`;
Wrapper.displayName = 'Wrapper';
